<template>
  <b-modal
    id="modal-multi-3"
    size="sm"
    title="Confirmación"
    ok-only
    ok-title="Accept"
    v-model="$store.state.someVariables.showConfirmacionRevisarPartido"
    @hidden="reset"
  >
    <div class="demo-inline-spacing">
      <b-form-radio v-model="opcion" name="radio-rol" value="1" class="mt-1">
        Marcar como revisado y generar valores por tarjetas amarillas y rojas
        automaticamente
      </b-form-radio>
      <b-form-radio v-model="opcion" name="radio-rol" value="2" class="mt-1">
        Solo marcar como revisado
      </b-form-radio>
    </div>
    <b-card-text class="my-1">
      Una vez guardado no podrás realizar cambios
      <br />
      ¿ Deseas continuar ?
    </b-card-text>
    <template #modal-footer>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="outline-primary"
        class="float-right mr-1"
        @click="close"
      >
        Cancelar
      </b-button>
      <b-button
        v-if="!showLoading"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="float-right"
        @click="ponerRevisado"
      >
        Confirmar
      </b-button>
      <div v-if="showLoading" class="text-center mt-1">
        <b-spinner variant="primary" label="Text Centered" />
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BCardText,
  BButton,
  BSpinner,
  BFormRadio,

  // xxx,
  // xxxx,
  // sss,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { ref } from '@vue/composition-api'
import apiCall from '../../utils/apiCall'
import {
  URL,
  USER,
  //   USER,
  //   ROLES,
  //   ESTADO_JUGADOR,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
} from '../../utils/variables'

export default {
  components: {
    BModal,
    BCardText,
    BButton,
    BSpinner,
    BFormRadio,
  },
  directives: {
    // 'b-popover': VBPopover,
    // heightFade,
    Ripple,
  },
  props: {
    dataPartido: Object,
    tarjetasAplicadas: Number,
  },
  setup(props, { emit }) {
    const showLoading = ref(false)
    const { postApi } = apiCall()
    const opcion = ref(null)
    function close() {
      store.commit('someVariables/UPDATE_SHOW_CONFIRMA_PARTIDO_REVISADO', false)
    }
    function reset() {
      opcion.value = null
    }
    async function ponerRevisado() {
      // console.log(opcion.value)
      if (opcion.value == null) {
        emit('error', 'Debes seleccionar una opcion')
      } else if (opcion.value === '1') {
        if (props.tarjetasAplicadas !== 0) {
          emit(
            'error',
            // eslint-disable-next-line
            'Debes aplicar las sanciones para continuar con el proceso'
          )
        } else {
          showLoading.value = true
          const path = 'ApiSanciones/revisarPartido'
          const data = {
            idPartido: props.dataPartido.id_partido,
            idLocal: props.dataPartido.id_local,
            idVisita: props.dataPartido.id_visita,
            generarValores: opcion.value,
            id_usuario_revisa: USER().id_usuario,
          }
          const response = await postApi(URL, path, data)
          if (response.flag === 'si') {
            // console.log('si')
            emit('ponerRevisado', data.idPartido)
            close()
            // dataPartido.value.voc_revisada = 's'
            // insertMultasTarjetasAutomatico()
          }
          showLoading.value = false
        }
      } else if (opcion.value === '2') {
        showLoading.value = true
        const path = 'ApiSanciones/revisarPartido'
        const data = {
          idPartido: props.dataPartido.id_partido,
          idLocal: props.dataPartido.id_local,
          idVisita: props.dataPartido.id_visita,
          generarValores: opcion.value,
          id_usuario_revisa: USER().id_usuario,
        }
        const response = await postApi(URL, path, data)
        if (response.flag === 'si') {
          // console.log('si')
          emit('ponerRevisado', data.idPartido)
          close()
          // dataPartido.value.voc_revisada = 's'
          // insertMultasTarjetasAutomatico()
        }
        showLoading.value = false
      }
    }

    return {
      close,
      ponerRevisado,
      showLoading,
      opcion,
      reset,
    }
  },
}
</script>
